import renderTopBar from './top_search_bar';

renderTopBar();
